import { createOperation } from "../operations";

export const getABTestsOperation = createOperation<string[] | null>("PARTY/GET_AB_TESTS");
